import * as constants from '../constants';

const initialState = {
    items: []
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getAgroEvents.success: {
            return action.payload;
        }

        case constants.updateAgroEvent.success: {
            return action.payload;
        }

        default:
            return state;
    }
}
